// import { gsap } from "gsap"
// import { ScrollTrigger } from "gsap/ScrollTrigger"
// const { $ } = window
//import { gettingStartedSlider } from "./blocks";

export default {
	init() {
      //gettingStartedSlider()
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}
